import { RootState } from "@app/redux/store";
import { createSelector } from "@reduxjs/toolkit";
import { Root } from "react-dom/client";

export const selectUniversity = (state: RootState) => state.search.university;
export const selectStudy = (state: RootState) => state.search.study;
export const selectSubject = (state: RootState) => state.search.subject;
